export default "__VITE_ASSET__B2j3ZbAj__"